export default "__VITE_PUBLIC_ASSET__2652d737__"